import { render, staticRenderFns } from "./my-info-page.vue?vue&type=template&id=636bcb7c&scoped=true&"
import script from "./my-info-page.vue?vue&type=script&lang=js&"
export * from "./my-info-page.vue?vue&type=script&lang=js&"
import style0 from "./my-info-page.vue?vue&type=style&index=0&id=636bcb7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636bcb7c",
  null
  
)

export default component.exports